export const TASK_DEFAULTS = {
    pageNumber: 0,
    rowsPerPage: 10,
    pageSize: 10,
    offset: 0,
    page: 0,
    isTeam: false,
    tab: "A",
    searchString: "",
    sortDirection: "DESC",
    sortField: "creationDate",
    sortBy: "ID",
    sortDDL: [
        { code: "PRIORITY", value: "taskOverview.priority" },
        { code: "DUE_DATE", value: "taskOverview.dueDate" },
        { code: "ID", value: "taskOverview.id" },
        { code: "TASK_NAME", value: "taskOverview.taskName" }
    ],
    priorityDDL: [
        { value: "priority.low", code: "L" },
        { value: "priority.medium", code: "M" },
        { value: "priority.high", code: "H" },
        { value: "priority.urgent", code: "U" }
    ],
    taskStatusDDL: [
        { id: "AT_RISK", name: "At risk Tasks" },
        { id: "OVERDUE", name: "Overdue Tasks" },
        { id: "TOTAL", name: "At risk Tasks" }
    ]
};
